import { StorageKeys } from '../../shared/models/storage-keys';
import { AuthoritiesConfig, Authorities } from '../../shared/config/authorities-config';
import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class UserAuthorityService {


	private appAuthorities: Authorities;
	private userAuthorities: string[];

	constructor(
		private localStorageService: LocalStorageService,
		private authorityConfig: AuthoritiesConfig,
	) {
		this.appAuthorities = this.authorityConfig.getAuthorities();
		this.userAuthorities = JSON.parse(this.localStorageService.get(StorageKeys.authorities));
	}

	hasAuthority(authority): boolean {
		this.userAuthorities = JSON.parse(this.localStorageService.get(StorageKeys.authorities));
		if (!authority || authority === 'all') {
			return true;
		}
		const authoritiesArray = authority.split(',');
		if (authoritiesArray.length > 1) {
			return authoritiesArray.some(str => this.userAuthorities.includes(str));
		}
		return this.userAuthorities?.includes(authority);
	}

	get UserAuthorities() {
		return this.userAuthorities;
	}

}
